export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/PG-f5ff4b613961e17235fce8f4a4d7b2f1.png";